module.exports = __webpack_public_path__ + "img/comfort.e167a02a.jpg";